export const CUSTOMER_CONNECTIONS_ROUTE="/customer-connection-details";